var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10710",
    "data-name": "Group 10710",
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.557,
    height: 54.557,
    viewBox: "0 0 54.557 54.557",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_361",
    "data-name": "Ellipse 361",
    cx: 27.279,
    cy: 27.279,
    r: 27.279,
    transform: "translate(0 0)",
    fill: "#394f65"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10709",
    "data-name": "Group 10709",
    transform: "translate(10.103 10.103)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10708",
    "data-name": "Group 10708"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6895",
    "data-name": "Path 6895",
    d: "M1574.092,236.041c4.586,0,5.129.017,6.941.1a9.5,9.5,0,0,1,3.189.592,5.689,5.689,0,0,1,3.26,3.26,9.5,9.5,0,0,1,.591,3.189c.082,1.811.1,2.354.1,6.94s-.018,5.129-.1,6.94a9.5,9.5,0,0,1-.591,3.189,5.689,5.689,0,0,1-3.26,3.26,9.513,9.513,0,0,1-3.189.592c-1.811.082-2.354.1-6.941.1s-5.129-.017-6.94-.1a9.513,9.513,0,0,1-3.189-.592,5.686,5.686,0,0,1-3.26-3.26,9.5,9.5,0,0,1-.591-3.189c-.083-1.811-.1-2.354-.1-6.941s.017-5.129.1-6.94a9.5,9.5,0,0,1,.591-3.189,5.686,5.686,0,0,1,3.26-3.26,9.5,9.5,0,0,1,3.189-.592c1.811-.082,2.354-.1,6.94-.1m0-3.095c-4.664,0-5.249.02-7.081.1a12.611,12.611,0,0,0-4.169.8,8.783,8.783,0,0,0-5.023,5.023,12.6,12.6,0,0,0-.8,4.169c-.084,1.832-.1,2.417-.1,7.082s.02,5.249.1,7.082a12.6,12.6,0,0,0,.8,4.169,8.783,8.783,0,0,0,5.023,5.023,12.613,12.613,0,0,0,4.169.8c1.832.084,2.417.1,7.081.1s5.25-.02,7.082-.1a12.613,12.613,0,0,0,4.169-.8,8.783,8.783,0,0,0,5.023-5.023,12.6,12.6,0,0,0,.8-4.169c.083-1.832.1-2.417.1-7.082s-.02-5.25-.1-7.082a12.605,12.605,0,0,0-.8-4.169,8.783,8.783,0,0,0-5.023-5.023,12.611,12.611,0,0,0-4.169-.8c-1.832-.084-2.417-.1-7.082-.1Z",
    transform: "translate(-1556.916 -232.946)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6896",
    "data-name": "Path 6896",
    d: "M1586.412,253.622a8.82,8.82,0,1,0,8.82,8.82A8.82,8.82,0,0,0,1586.412,253.622Zm0,14.545a5.725,5.725,0,1,1,5.725-5.725A5.725,5.725,0,0,1,1586.412,268.167Z",
    transform: "translate(-1569.236 -245.266)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_362",
    "data-name": "Ellipse 362",
    cx: 2.061,
    cy: 2.061,
    r: 2.061,
    transform: "translate(24.283 5.946)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.3bfe8a75ceb9c263b4e97d1320cefd1b.svg";
export { ForwardRef as ReactComponent };